import { createApi } from '@reduxjs/toolkit/query/react';
import { IPagedResult } from '../../shared/models/paged-result';
import { ICreditNoteListItem } from '../../shared/models/reception/credit-note-list-item';
import { baseQuery } from './baseQuery';

export const creditNoteApi = createApi({
  reducerPath: 'creditNoteApi',
  baseQuery,
  endpoints: (builder) => ({
    creditNoteList: builder.query<IPagedResult<ICreditNoteListItem>, string>({
      query: (params) => ({
        url: `/api/creditnotes?${params}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyCreditNoteListQuery } = creditNoteApi;
